import React, { useState } from 'react'
import HomeLeft from '../home/home_left/HomeLeft'
import { useQuery } from '@apollo/client';
import {GET_AVATAR_USER_MANAGE, USER_PACKAGES_OF_YEAR} from '../../graphql-client/Queries';
import { useMutation } from '@apollo/client';
import { CREATE_FREE_USER_PACKAGE } from '../../graphql-client/Mutation';
import moment from 'moment';
import { useAuthContext } from '../../context/AuthContext';
import NotificationError from '../NotificationError';
import './SubscribePackage.css';
// import { user } from '../../../../server/src/resolver/Query';
export default function SubscribePackage() {
    const {isAuthenticated} = useAuthContext();
    const [referrerId, setReferrerId] = useState('');
    // Mutation để tạo gói cước miễn phí
    const [promotionCode, setPromotionCode] = useState('');
    const [freePackageMessage, setFreePackageMessage] = useState('');
    const [createFreeUserPackage, { loading: loadingFree, error: errorFree }] = 
     useMutation(
        CREATE_FREE_USER_PACKAGE,
        {
            update(cache, { data }) {
                if (data?.createFreeUserPackage) {
                    // Đọc dữ liệu user hiện tại từ cache
                        const existing = cache.readQuery({ query: GET_AVATAR_USER_MANAGE });
                        if (existing && existing.userManage) {
                        // Tăng monthlyWatchTime lên theo watchTime của gói mới
                        const newMonthlyWatchTime =
                            (existing.userManage.monthlyWatchTime || 0) +
                            (data.createFreeUserPackage.watchTime || 0);
                        const newMonthlyUploadSize =
                        (existing.userManage.monthlyUploadSize || 0) +
                        (data.createFreeUserPackage.uploadSize || 0);
                        cache.writeQuery({
                            query: GET_AVATAR_USER_MANAGE,
                            data: {
                            userManage: {
                                ...existing.userManage,
                                monthlyWatchTime: newMonthlyWatchTime,
                                monthlyUploadSize: newMonthlyUploadSize,
                            },
                            },
                        });
                        }
                    }
                },
            }
    );

     // Fetch dữ liệu từ GraphQL
     const { loading, error, data } = useQuery(GET_AVATAR_USER_MANAGE);
     const { data: dataPackages } = useQuery(USER_PACKAGES_OF_YEAR
        // , {
        // variables: { userId: data?.userManage?.id } // Lấy ID người dùng từ dữ liệu đã fetch
    //  }
    );

     if(!isAuthenticated) return (
        <NotificationError text={'Hãy đăng nhập hoặc đăng ký để có thể tiếp tục.'}></NotificationError>
    )
     if (loading) return <p>Loading...</p>;
    if (error) return <p>{error.message}</p>;
    const userManage = data.userManage;
    const yearPackages = dataPackages?.userPackagesOfYear || dataPackages?.userPackageOfYear || [];
    const isTimeWatch = yearPackages.length > 0
        ? data.userManage.monthlyWatchTime + data.userManage.extraWatchTime
        : data.userManage.monthlyWatchTime;

    const packageFeatures = [
        'Tải tài liệu (PDF) miễn phí không giới hạn',
        'Lưu trữ tài liệu (PDF/QUIZ) không giới hạn',
        'Xem tài liệu (PDF) không giới hạn',
        'Làm bài tập trắc nghiệm (QUIZ) không giới hạn',
    ];

    const monthlyPlans = [
        {
            id: 'time-10',
            type: 'video',
            tag: 'Xem video',
            title: 'Gói Khám Phá',
            description: 'Tải, xem không giới hạn tài liệu PDF và QUIZ cùng với 10 giờ xem video bài giảng trong tháng.',
            highlight: '10 giờ / tháng',
            price: '60.000',
            amount: 60000,
            purchaseType: 'TIME'
        },
        {
            id: 'storage-10',
            type: 'storage',
            tag: 'Lưu trữ',
            title: 'Gói Tủ Sách',
            description: 'Lưu trữ tài liệu PDF, QUIZ không giới hạn cùng với 10 GB dung lượng video trong tháng.',
            highlight: '10 GB / tháng',
            price: '70.000',
            amount: 70000,
            purchaseType: 'DATA'
        },
        {
            id: 'time-20',
            type: 'video',
            tag: 'Xem video',
            title: 'Gói Bứt Phá',
            description: 'Tải, xem không giới hạn tài liệu PDF và QUIZ Tăng tốc với 20 giờ xem video bài giảng trong tháng.',
            highlight: '20 giờ / tháng',
            price: '100.000',
            amount: 100000,
            purchaseType: 'TIME'
        },
        {
            id: 'storage-20',
            type: 'storage',
            tag: 'Lưu trữ',
            title: 'Gói Thư Viện',
            description: 'Lưu trữ tài liệu PDF, QUIZ không giới hạn cùng với 20 GB dung lượng video trong tháng.',
            highlight: '20 GB / tháng',
            price: '120.000',
            amount: 120000,
            purchaseType: 'DATA'
        }
    ];

    const handlePurchase = async ( price,description) => {
        
        const response = await fetch(process.env.REACT_APP_URL_WEB_SERVER_ROUTER_CREATE_PAYMENT_LINK, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                amount: price, // Giá sản phẩm
                description:description, // Mô tả sản phẩm
                returnUrl: process.env.REACT_APP_URL_ROUTER_CLIENT_SUBSCRIPTION,
                cancelUrl: process.env.REACT_APP_URL_ROUTER_CLIENT_SUBSCRIPTION,
                referrerId: referrerId,
                buyer: {
                    name: userManage.username,
                    email: userManage.email,
                    id: userManage.id,
                },
            }),
        });
    
        const data = await response.json();
        if (data.checkoutUrl) {
            window.open(data.checkoutUrl, "_blank");
        } else if (data.error && data.error.includes('số tiền không đủ')) {
            alert('Giao dịch không thành công: số tiền không đủ để mua gói năm.');
        } else {
            alert('Đã có lỗi xảy ra khi tạo liên kết thanh toán hoặc bạn nhập sai thông tin. Vui lòng thử lại sau.');
        }
    };
    
    const formatDurationText=(seconds) =>{
        const duration = moment.duration(seconds, 'seconds');
        const hours = duration.hours();
        const totalHours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        
        if (hours > 0) {
            return `${totalHours} giờ ${minutes} phút`;
        } else {
            return `${minutes} phút`;
        }
    }
    function convertMBtoGB(mb) {
        return (mb / 1024).toFixed(2); // Giữ 2 chữ số sau dấu phẩy
    }
    // hàm nhận mã khuyến mại và tạo gói cước miễn phí
    const handleFreePackage = async () => {
        if (!promotionCode) {
            setFreePackageMessage('Vui lòng nhập mã khuyến mại!');
            return;
        }
        try {
            const { data } = await createFreeUserPackage({
                variables: {
                    userId: userManage.id,
                    promotionCode: promotionCode
                }
            });
            if (data?.createFreeUserPackage) {
                setFreePackageMessage('Đã nhận thời gian xem miễn phí thành công!');
            }
        } catch (err) {
            setFreePackageMessage(err.message || 'Mã khuyến mại không hợp lệ!');
        }
    };

    return (
        <div className='row'>
            <HomeLeft />
            <main className='col-xxl-10 col-xl-10 col-lg-10 col-mb-10 col-sm-12 sp-page'>
                <div className="sp-wrap">
                    <header className="top-header">
                        {/* <div className="logo">Link<span>learn</span>.vn</div> */}
                        {/* <img src='/IconOnly.png' alt='Logo' /> */}
                        <div className="nav-label">Nâng cấp tài khoản</div>
                    </header>

                    <section className="usage-card" aria-label="Thông tin sử dụng">
                        <div>
                            <p className="usage-section-label">Thông tin sử dụng</p>
                            <div className="usage-stats">
                                <article className="stat-item">
                                    <div className="stat-icon">⏱</div>
                                    <div>
                                        <p className="stat-label">Thời gian xem video còn lại</p>
                                        <p className="stat-val">{formatDurationText(isTimeWatch)}</p>
                                    </div>
                                </article>

                                <article className="stat-item">
                                    <div className="stat-icon">📦</div>
                                    <div>
                                        <p className="stat-label">Dung lượng tải lên chưa dùng</p>
                                        <p className="stat-val">{convertMBtoGB(userManage.monthlyUploadSize)} GB</p>
                                    </div>
                                </article>
                            </div>
                        </div>

                        <div className="user-badge">{userManage.username}</div>
                    </section>

                    <h2 className="section-title">Khuyến mãi</h2>
                    <section className="promo-box" aria-labelledby="promo-heading">
                        <div className="promo-header">
                            <div className="promo-icon" aria-hidden="true">🎁</div>
                            <h3 id="promo-heading">Nhập mã khuyến mãi</h3>
                        </div>
                        <p className="promo-desc">
                            Nhận thêm thời gian xem hoặc dung lượng miễn phí. Theo dõi
                            <a className="fb-link" href="https://www.facebook.com/share/16pjbqqc8M/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
                                {' '}trang Facebook của chúng tôi
                            </a>
                            {' '}để nhận mã khuyến mãi mới nhất.
                        </p>

                        <div className="input-row">
                            <input
                                type="text"
                                placeholder="Nhập mã khuyến mãi tại đây..."
                                value={promotionCode}
                                onChange={e => setPromotionCode(e.target.value)}
                            />
                            <button
                                type="button"
                                className="btn-primary"
                                onClick={handleFreePackage}
                                disabled={loadingFree}
                            >
                                {loadingFree ? 'Đang xử lý...' : 'Nhận ngay'}
                            </button>
                        </div>
                        {(freePackageMessage || errorFree) && (
                            <p className="promo-message">{freePackageMessage || errorFree?.message}</p>
                        )}
                    </section>

                    <h2 className="section-title section-title-spaced">Gói cước năm</h2>
                    <section className="annual-box" aria-labelledby="annual-title">
                        <div className="annual-inner">
                            <p className="annual-badge">⭐ Tiết kiệm nhất - 30%</p>
                            <h3 id="annual-title" className="annual-title">Gói Chinh Phục</h3>
                            <p className="annual-desc">
                                Trọn năm học, không giới hạn · thêm 240 giờ xem toàn bộ video bài giảng trên Linklearn.vn.
                            </p>
                            <ul className="annual-feature-list" aria-label="Tính năng gói cước năm">
                                {packageFeatures.map((feature) => (
                                    <li key={`annual-${feature}`}>{feature}</li>
                                ))}
                            </ul>
                            <div className="annual-pricing">
                                <span className="price-original">1.200.000 VNĐ</span>
                                <span className="price-new">840.000</span>
                                <span className="price-period">VNĐ / 12 tháng</span>
                            </div>
                            <div className="annual-input-row">
                                <input
                                    type="text"
                                    placeholder="Nhập ID người giới thiệu (nếu có)..."
                                    value={referrerId}
                                    onChange={e => setReferrerId(e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="btn-white"
                                    onClick={() => handlePurchase(840000, 'TIME')}
                                >
                                    Mua ngay
                                </button>
                            </div>
                        </div>
                    </section>

                    <h2 className="section-title">Gói cước tháng</h2>
                    <section className="plans-grid" aria-label="Danh sách gói cước tháng">
                        {monthlyPlans.map((plan) => (
                            <article className="plan-card" key={plan.id}>
                                <p className={`plan-type-tag ${plan.type === 'video' ? 'tag-video' : 'tag-storage'}`}>
                                    {plan.type === 'video' ? '▶' : '☁'} {plan.tag}
                                </p>
                                <h3>{plan.title}</h3>
                                <p>{plan.description}</p>

                                {/* <div className="plan-highlight">
                                    <span className={`dot ${plan.type === 'video' ? 'dot-green' : 'dot-blue'}`} />
                                    {plan.highlight}
                                </div> */}

                                <ul className="plan-feature-list" aria-label={`Tính năng ${plan.title}`}>
                                    {packageFeatures.map((feature) => (
                                        <li key={`${plan.id}-${feature}`}>{feature}</li>
                                    ))}
                                </ul>

                                <div className="plan-price">
                                    <span className="plan-price-val">{plan.price}</span>
                                    <span className="plan-price-unit">VNĐ / tháng</span>
                                </div>

                                <button
                                    type="button"
                                    className="btn-outline"
                                    onClick={() => handlePurchase(plan.amount, plan.purchaseType)}
                                >
                                    Mua ngay
                                </button>
                            </article>
                        ))}
                    </section>
                </div>
            </main>
        </div>
    )
}